import { InterruptionTypeModelAPI } from '../../../../models';
import { InterruptionAllowedCover } from '../../../../models/interruptions/interruptionAllowedCover';
import { getInterruptionTypesListAdapter } from '../../Adapters/interruptions/InterruptionType.adapter';
import { requests } from '../apiAgent';

export const InterruptionTypeAPI = {
    getInterruptionsType: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/interruption-types')
            .then((response: InterruptionTypeModelAPI[]) =>
                getInterruptionTypesListAdapter(response)
            );
    },

    getInterruptionsTypeByUser: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/interruption-types/by-user')
            .then((response: InterruptionTypeModelAPI[]) =>
                getInterruptionTypesListAdapter(response)
            );
    },

    getInterruptionsTypeByEmployeePortal: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/interruption-types/get-interruption-types-for-employee-portal'
            )
            .then((response: InterruptionTypeModelAPI[]) =>
                getInterruptionTypesListAdapter(response)
            );
    },

    getInterruptionsAllowedToCoverType: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/interruption-types/get-interruptions-types-valid-for-cover'
            )
            .then((response: InterruptionAllowedCover[]) => response);
    },
};
